/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

 document.addEventListener("DOMContentLoaded", (event) => {
  var metaProductsAddButton = $('.product-single__box__block-meta-products-button button');
  if (metaProductsAddButton.length) {
var loadedProducts = {};
var ProductLoader = class {
  static load(productHandle) {
    if (!productHandle) {
      return;
    }
    if (loadedProducts[productHandle]) {
      return loadedProducts[productHandle];
    }
    loadedProducts[productHandle] = new Promise(async (resolve, reject) => {
      const response = await fetch(`${Shopify.routes.root}products/${productHandle}.js`);
      if (response.ok) {
        const responseAsJson = await response.json();
        resolve(responseAsJson);
      } else {
        reject(`
          Attempted to load information for product with handle ${productHandle}, but this product is in "draft" mode. You won't be able to
          switch between variants or access to per-variant information. To fully preview this product, change temporarily its status
          to "active".
        `);
      }
    });
    return loadedProducts[productHandle];
  }
};
    
  var getSelectedOptionValues = function(optionSelectors) {
  return optionSelectors.map((index,optionSelector) => {
    return optionSelector.value;
  });
};  
  var getVariantFromOptions= function(optionSelectors,productJSON) {  
  const options = getSelectedOptionValues(optionSelectors);
 // debugger;
  return productJSON["variants"].find((variant) => {
    return variant["options"].every((value, index) => value === options[index]);
  });
};

var updateDisableSelectors = async function(selectedVariant,optionSelectors,productHandle,currentSelector) {
  var productJSON = await ProductLoader.load(productHandle);
  const applyClassToSelector = (selector, valueIndex, available, hasAtLeastOneCombination) => {
    const optionValue = Array.from(selector.querySelectorAll("option"))[valueIndex+1];
   // debugger;
    //optionValue.toggleAttribute("hidden", !hasAtLeastOneCombination);
    if(available){
      optionValue.innerHTML = optionValue.value;
      optionValue.removeAttribute("disabled");
    }else{      
       optionValue.setAttribute("disabled", "disabled");
       if(!hasAtLeastOneCombination){
          optionValue.innerHTML = optionValue.value + " - " + window.theme.t.unavailable;
       }else{
         optionValue.innerHTML = optionValue.value + " - " + window.theme.t.sold_out;
       }
    }
    //optionValue.classList.toggle("is-disabled", !available);
  };

  var index = currentSelector.closest(".selector-wrapper").index();
  var lastSelector = false;
  if(optionSelectors.length == (index+1)){
    lastSelector = true;
  }else{
  
    for(var i=index;i<optionSelectors.length;i++){
      //debugger;
      if(optionSelectors[i+1]){
        optionSelectors[i+1].value = optionSelectors[i+1].getAttribute("data-option-name");
        metaProductsAddButton.attr("disabled","disabled");
      }
    }
  }
  
  
  if (selectedVariant && lastSelector) {
    
  if (optionSelectors && optionSelectors[0]) {
    productJSON["options"][0]["values"].forEach((value, valueIndex) => {
      const hasAtLeastOneCombination = productJSON["variants"].some((variant) => variant["option1"] === value && variant), hasAvailableVariant = productJSON["variants"].some((variant) => variant["option1"] === value && variant["available"]);
      applyClassToSelector(optionSelectors[0], valueIndex, hasAvailableVariant, hasAtLeastOneCombination);
      if (optionSelectors[1]) {
        productJSON["options"][1]["values"].forEach((value2, valueIndex2) => {
          const hasAtLeastOneCombination2 = productJSON["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant), hasAvailableVariant2 = productJSON["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant["available"]);
          applyClassToSelector(optionSelectors[1], valueIndex2, hasAvailableVariant2, hasAtLeastOneCombination2);
          if (optionSelectors[2]) {
            productJSON["options"][2]["values"].forEach((value3, valueIndex3) => {
              const hasAtLeastOneCombination3 = productJSON["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant), hasAvailableVariant3 = productJSON["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant["available"]);
              applyClassToSelector(optionSelectors[2], valueIndex3, hasAvailableVariant3, hasAtLeastOneCombination3);
            });
          }
        });
      }
    });
  }
}else{
   // debugger;
     if (optionSelectors && optionSelectors[0]) {
       if(optionSelectors[0].value != optionSelectors[0].getAttribute("data-option-name")){
          var firstSelectorValue = optionSelectors[0].value;  
          if (optionSelectors[1]) {
              productJSON["options"][1]["values"].forEach((value2, valueIndex2) => {
              const hasAtLeastOneCombination2 = productJSON["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === firstSelectorValue && variant), hasAvailableVariant2 = productJSON["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === firstSelectorValue && variant["available"]);
              applyClassToSelector(optionSelectors[1], valueIndex2, hasAvailableVariant2, hasAtLeastOneCombination2);             
            });     
             if (optionSelectors[1].value != optionSelectors[1].getAttribute("data-option-name") && optionSelectors[2]) {
                var secondSelectorValue = optionSelectors[1].value;  
                productJSON["options"][2]["values"].forEach((value3, valueIndex3) => {
                  const hasAtLeastOneCombination3 = productJSON["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === firstSelectorValue && variant["option2"] === secondSelectorValue && variant), hasAvailableVariant3 = productJSON["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === firstSelectorValue && variant["option2"] === secondSelectorValue && variant["available"]);
                  applyClassToSelector(optionSelectors[2], valueIndex3, hasAvailableVariant3, hasAtLeastOneCombination3);
                });
              }else if(optionSelectors[2]){
                 productJSON["options"][2]["values"].forEach((value3, valueIndex3) => {
                  const hasAtLeastOneCombination3 = productJSON["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === firstSelectorValue && variant), hasAvailableVariant3 = productJSON["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === firstSelectorValue && variant["available"]);
                  applyClassToSelector(optionSelectors[2], valueIndex3, hasAvailableVariant3, hasAtLeastOneCombination3);
                });
              }
            
          }         
       }
     }
}
};
    
    
 
  $(".product-single__box__block-meta-product-options select").on("change",function(){
    var parentContainer =  $(this).closest(".product-single__box__block-meta-product");
    var productHTML = parentContainer.find(".meta-product-json").html();
    var productJSON = JSON.parse(productHTML);
    var optionSelectors = parentContainer.find(".product-single__box__block-meta-product-options select");
    var variant = getVariantFromOptions(optionSelectors,productJSON);
    if(typeof variant != "undefined"){
      var priceContainer = parentContainer.find(".price-block");
      var variantInput = parentContainer.find(".meta-product-variant-id");
      priceContainer.html(Shopify.formatMoney(variant.price,theme.money_format));
      variantInput.val(variant.id);
      metaProductsAddButton.removeAttr("disabled");
      updateDisableSelectors(variant,optionSelectors,productJSON.handle,$(this));
    }else{
      updateDisableSelectors(null,optionSelectors,productJSON.handle,$(this));
    }
  });  
  }
  });                        